import { Injectable } from "@angular/core";
import { SiteAppCommand } from "@fabric-types/app-site";
import { Store } from "@ngrx/store";
import { CommonState, GeoFencingAction } from "@obg/ngx.common";
import { GeolocationService } from "@obg/ngx.core";
import { DocumentRef } from "@obg/ngx.global";

import { GeofencingConfigService } from "./geofencing.config";
import { GeofencingExperimentService } from "./geofencing.experiment.service";

@Injectable({ providedIn: "root" })
export class GeofencingService {
	constructor(
		private configService: GeofencingConfigService,
		private experimentService: GeofencingExperimentService,
		private geoLocationService: GeolocationService,
		private docRef: DocumentRef,
		private store: Store<CommonState>
	) {
		this.docRef.obgEventBus?.listen(SiteAppCommand.ValidateLocation, () => {
			this.store.dispatch(GeoFencingAction.validateBrazilLocation());
		});
	}

	isRouteExempt(route?: string): boolean {
		return route ? this.configService.getArgentinaGeoFenceExemptRoutes().includes(route) : false;
	}

	isArgentinaGeofencingEnabled(): boolean {
		return !this.experimentService.isGeofencingDisabled() && this.configService.isArgentinaGeofencingEnabled();
	}

	isBrazilGeofencingEnabled(): boolean {
		return this.geoLocationService.isBrazilGeofencingEnabled();
	}

	isAwsLocationServiceEnabled(): boolean {
		return !this.experimentService.isGeofencingDisabled() && this.configService.isAwsLocationServiceEnabled();
	}

	isWageringBlockDialogEnabled(): boolean {
		return this.configService.isWageringBlockDialogEnabled();
	}
}
